import React from "react";
import { Layout } from "antd";
import { useNavigate } from "react-router-dom";
import fullLogo from "src/assets/full-logo.png";
import {
  getDistributorCode,
  getDistributorLogo,
} from "src/util/distributorBranding.service";
import { NotificationPopover } from "./NotificationPopover";
import { LanguageSelector } from "./LanguageSelector";
import { ProfileMenu } from "./ProfileMenu";
import { ROUTE_CONSTANTS } from "src/routes/routeConstant";
import { requestGuardedNavigation } from "src/util/navigationGuard";
import HighLevelUserAccess from "./HighLevelUserAccess";

const { Header } = Layout;

interface HeaderBarProps {
  privacyPolicyBlocking: boolean;
}

export const HeaderBar: React.FC<HeaderBarProps> = ({ privacyPolicyBlocking }) => {
  const navigate = useNavigate();
  const logo = getDistributorLogo(fullLogo);
  const isVei = getDistributorCode() === "vei";

  const handleLogoClick = () => {
    requestGuardedNavigation(() => navigate(ROUTE_CONSTANTS.HOME));
  };

  return (
    <Header className="h-[80px] w-full top-0 z-[1000] !p-0 fixed !bg-white shadow-sm">
      <div className="flex items-center justify-between h-full pl-5 pr-10">
        <div className="flex items-center h-full">
          <img
            src={logo}
            alt="Logo"
            className={
              isVei
                ? "h-[48px] w-[130px] object-contain object-left cursor-pointer"
                : "max-w-37.5 max-h-12 w-auto h-auto object-contain cursor-pointer"
            }
            onClick={handleLogoClick}
          />
        </div>
        <div className="flex items-center gap-x-4 admin-popover">
          <HighLevelUserAccess privacyPolicyBlocking={privacyPolicyBlocking} />
          <LanguageSelector />
          <NotificationPopover />
          <ProfileMenu />
        </div>
      </div>
    </Header>
  );
};

export default HeaderBar;
